export default __webpack_public_path__ + "static/media/Punto_01_Porto_Mediceo_ITA_Def.ecf93178.aac";